export function formatDate(secs) {
    // 123456789 --> 年-月-日 时：分：秒
    var t = new Date(secs)
    var year = t.getFullYear()
    var month = t.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    var date = t.getDate()
    if (date < 10) {
      date = '0' + date
    }
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    var second = t.getSeconds()
    if (second < 10) {
      second = '0' + second
    }
    return (
      year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
    )
  }
  export function formatDateNoSecond(secs) {
    // 123456789 --> 年-月-日 时：分
    var t = new Date(secs)
    var year = t.getFullYear()
    var month = t.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    var date = t.getDate()
    if (date < 10) {
      date = '0' + date
    }
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    var second = t.getSeconds()
    if (second < 10) {
      second = '0' + second
    }
    return year + '-' + month + '-' + date + ' ' + hour + ':' + minute
  }
  export function DateNoSecond(secs) {
    // 123456789 --> 日 时：分
    var t = new Date(secs)
    var date = t.getDate()
    if (date < 10) {
      date = '0' + date
    }
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    return date + '天' + hour + '时' + minute + "分"
  }
  export function NoSecond(secs) {
    // 123456789 -->时：分
    var t = new Date(secs)
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    return hour + '时' + minute + "分"
  }
  export function Second(secs) {
    // 123456789 --> 日 时：分
    var t = new Date(secs)
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    return minute + "分"
  }
  export function formatDateNoHouer(secs) {
    // 123456789 --> 年-月-日
    var t = new Date(secs)
    var year = t.getFullYear()
    var month = t.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    var date = t.getDate()
    if (date < 10) {
      date = '0' + date
    }
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    var second = t.getSeconds()
    if (second < 10) {
      second = '0' + second
    }
    return year + '-' + month + '-' + date
  }
  
  // 汉字格式
  export function formatDateForChinese(secs) {
    // 123456789 --> 年-月-日
    var t = new Date(secs)
    var year = t.getFullYear()
    var month = t.getMonth() + 1
    if (month < 10) {
      month = '0' + month
    }
    var date = t.getDate()
    if (date < 10) {
      date = '0' + date
    }
    var hour = t.getHours()
    if (hour < 10) {
      hour = '0' + hour
    }
    var minute = t.getMinutes()
    if (minute < 10) {
      minute = '0' + minute
    }
    var second = t.getSeconds()
    if (second < 10) {
      second = '0' + second
    }
    return year + '年' + month + '月' + date + '日'
  }
  

        //时间转换
 export function getDuration(second) {
        var duration
        var days = Math.floor(second / 86400);
        var hours = Math.floor((second % 86400) / 3600);
        var minutes = Math.floor(((second % 86400) % 3600) / 60);
        var seconds = Math.floor(((second % 86400) % 3600) % 60);
          if(days>0)
            duration = days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
          else if(hours>0)
           duration = hours + "小时" + minutes + "分" + seconds + "秒";
          else if(minutes>0)
           duration = minutes + "分" + seconds + "秒";
          else if(seconds>0)
           duration = seconds + "秒";
          return  duration
  }
        
    